export default "__VITE_ASSET__yV_5TlJC__"